import script from "./information.vue?vue&type=script&setup=true&lang=js"
export * from "./information.vue?vue&type=script&setup=true&lang=js"

import "./information.vue?vue&type=style&index=0&id=68dd947a&scoped=true&lang=postcss"
import "./information.vue?vue&type=style&index=1&id=68dd947a&lang=postcss"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68dd947a"]])

export default __exports__